import React from "react";
import "./footer.css";

export default function Footer() {
  return (
    <footer class="card__footer">
      <p class="card__footer-content">
        This project is
        <a
          href="https://github.com/katerinacorn/weather-api-app"
          class="card__footer-link"
          target="_blank"
          rel="noreferrer"
        >
          open-sourced on GitHub.
        </a>
      </p>
    </footer>
  );
}